<template>
  <div class="p-6 border rounded-2xl mt-12">
    <h1 class="font-bold text-lg">Connected Channels</h1>
    <div
      class="flex mt-4 cursor-pointer"
      v-for="(channel, index) in ChannelList"
      :key="'item -' + index"
      @click="handleChannelClick(channel)"
    >
      <div>
        <img
          :src="$imageURL + '/' + channel.picture"
          class="rounded-full w-12 h-12 object-cover"
        />
      </div>
      <div class="ml-4">
        <h3 class="font-semibold text-base specialcourse ellipsis-2">
          {{ channel.name }}
        </h3>
        <span>{{ channel.description.slice(0, 21) }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
export default {
  data() {
    return {
      filterdata: [],
      probottom: [
        {
          img: require("@/assets/images/courses/1.png"),
          title: "Caregiver",
        },
        {
          img: require("@/assets/images/courses/1.png"),
          title: "Caregiver",
        },
        {
          img: require("@/assets/images/courses/1.png"),
          title: "Caregiver",
        },
      ],
    };
  },
  methods: {
    async handleChannelClick(channel) {
      const payload = {
        userid: this.user._id,
        channelid: channel._id,
      };
      const data = await this.$store.dispatch(
        "posts/FeedUserIdChannelId",
        payload
      );
    },

    async getUserChannel() {
      try {
        let data = await this.$store.dispatch("channel/GetALLChannel", {});
      } catch (error) {
        if (error.response.data.code == 401) {
          this.$router.push({ name: "signin" });
          this.$swal.fire({
            title: "Session Expired",
            text: "Your session has ended and for security reasons, we request you to login again",
            icon: "warning",
            confirmButtonColor: "#830c81",
            showCancelButton: false,
          });
        }
      }
    },
  },
  computed: {
    ...mapGetters("channel", {
      ChannelList: "currentUserChannel",
    }),

    ...mapState("auth", {
      user: "user",
    }),
  },
  async mounted() {
    this.$store.dispatch("posts/getChannelPosts");

    this.getUserChannel();
  },
};
</script>
